import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            't',
        ]),
        definedButtons() {
            const t = this.t;
            return this.getItems.map((item) => {
                return t(item, "name").charAt(0);
            });
        }
    },
}
